import React from 'react';
import SITE from './siteConfig';

// Páginas legales públicas: /terminos, /privacidad, /tratamiento-datos, /cookies, /eliminacion-datos.
// BORRADOR: revisar con un abogado antes de publicar. Los datos faltantes de siteConfig
// se muestran resaltados como "pendiente".
// /privacy.html (registrada en Meta) es un archivo estático aparte y no se toca aquí.

function Val({ value, missing }) {
  if (value) return <>{value}</>;
  return <mark className="lg-missing">[{missing} pendiente]</mark>;
}

const OWNER = () => (
  <>
    <Val value={SITE.legalName} missing="Razón social" /> (identificado con NIT/C.C. <Val value={SITE.legalId} missing="NIT" />),
    con domicilio en <Val value={SITE.city} missing="Ciudad" />
  </>
);
const EMAIL = () => <Val value={SITE.email} missing="Correo de contacto" />;

const PAGES = {
  terminos: {
    title: 'Términos y Condiciones',
    body: () => (
      <>
        <h2>1. Aceptación</h2>
        <p>Estos Términos regulan el uso de {SITE.brand} ({SITE.domain}), plataforma operada por <OWNER />. Al crear una cuenta o usar la plataforma aceptas estos Términos. Si actúas en nombre de una empresa, declaras que tienes facultades para obligarla.</p>

        <h2>2. El servicio</h2>
        <p>{SITE.brand} es un software de gestión de relaciones con clientes (CRM) que permite centralizar conversaciones de WhatsApp, Instagram y Messenger, automatizar respuestas con inteligencia artificial, gestionar pedidos, pagos, guías de envío y campañas. Las funciones disponibles pueden variar según el plan contratado y pueden actualizarse con el tiempo.</p>

        <h2>3. Cuenta y acceso</h2>
        <p>Eres responsable de la información que registras, de mantener la confidencialidad de tus credenciales y de toda actividad realizada desde tu cuenta y las de tu equipo. Debes avisarnos de inmediato si detectas un uso no autorizado.</p>

        <h2>4. Uso aceptable</h2>
        <p>Te comprometes a usar la plataforma conforme a la ley y a las políticas de los servicios conectados, en especial las Políticas de WhatsApp Business y de Meta. No está permitido enviar spam o mensajes no solicitados, suplantar identidades, difundir contenido ilegal, engañoso u ofensivo, ni intentar vulnerar la seguridad de la plataforma.</p>

        <h2>5. Servicios de terceros</h2>
        <p>{SITE.brand} se integra con servicios de terceros como Meta (WhatsApp, Instagram y Messenger), Shopify, operadores logísticos y transportadoras, pasarelas y entidades de pago y proveedores de inteligencia artificial. El uso de esos servicios está sujeto a sus propios términos. {SITE.brand} no es responsable por sus fallas, cambios, suspensiones o decisiones, incluidas las aprobaciones de plantillas o las restricciones de números por parte de Meta.</p>

        <h2>6. Inteligencia artificial</h2>
        <p>Las respuestas generadas por inteligencia artificial se basan en la información que configures. Pueden contener errores, por lo que eres responsable de revisar la configuración de tus agentes y la información que se entrega a tus clientes. Puedes pausar la IA en cualquier conversación.</p>

        <h2>7. Tus datos y los de tus clientes</h2>
        <p>Conservas la titularidad de la información que cargas en la plataforma. Frente a los datos personales de tus clientes, tú actúas como Responsable del tratamiento y {SITE.brand} como Encargado, conforme a nuestra <a href="/tratamiento-datos">Política de Tratamiento de Datos Personales</a>. Debes contar con la autorización de tus clientes para contactarlos.</p>

        <h2>8. Pagos</h2>
        <p>Los valores, la periodicidad y las condiciones de pago del servicio son los acordados en tu plan o cotización. La falta de pago puede dar lugar a la suspensión del servicio.</p>

        <h2>9. Disponibilidad</h2>
        <p>Trabajamos para mantener la plataforma disponible y segura, pero no garantizamos un funcionamiento ininterrumpido o libre de errores. Podemos realizar mantenimientos y actualizaciones.</p>

        <h2>10. Suspensión y terminación</h2>
        <p>Puedes dejar de usar el servicio en cualquier momento. Podemos suspender o cancelar cuentas que incumplan estos Términos o que pongan en riesgo la plataforma, a otros usuarios o a terceros.</p>

        <h2>11. Limitación de responsabilidad</h2>
        <p>En la medida permitida por la ley, {SITE.brand} no será responsable por lucro cesante, pérdida de ventas o daños indirectos derivados del uso o la imposibilidad de uso de la plataforma, ni por hechos de terceros.</p>

        <h2>12. Propiedad intelectual</h2>
        <p>El software, la marca y los contenidos de {SITE.brand} son de su titular. No se concede ningún derecho sobre ellos más allá del uso del servicio.</p>

        <h2>13. Cambios</h2>
        <p>Podemos actualizar estos Términos. Publicaremos la nueva versión en esta página con su fecha de actualización.</p>

        <h2>14. Ley aplicable y contacto</h2>
        <p>Estos Términos se rigen por las leyes de la República de Colombia. Para cualquier inquietud escríbenos a <EMAIL />.</p>
      </>
    ),
  },

  privacidad: {
    title: 'Política de Privacidad',
    body: () => (
      <>
        <h2>1. Quiénes somos</h2>
        <p>{SITE.brand} ({SITE.domain}) es operada por <OWNER />. Contacto: <EMAIL />.</p>

        <h2>2. Qué datos tratamos</h2>
        <ul>
          <li><b>Datos de usuarios de la plataforma:</b> nombre, correo, empresa, teléfono y datos de acceso.</li>
          <li><b>Datos de los clientes de nuestros usuarios:</b> nombre, teléfono, dirección de envío, mensajes, archivos multimedia, pedidos y estado de pagos y envíos, que nuestros usuarios gestionan a través de la plataforma.</li>
          <li><b>Datos técnicos:</b> información necesaria para el funcionamiento y la seguridad del servicio.</li>
        </ul>

        <h2>3. Para qué los usamos</h2>
        <p>Para prestar el servicio: mostrar y enviar mensajes, operar los agentes de inteligencia artificial, gestionar pedidos, pagos, guías y notificaciones, enviar campañas configuradas por el usuario, brindar soporte y mantener la seguridad de la plataforma. No vendemos datos personales.</p>

        <h2>4. Con quién los compartimos</h2>
        <p>Solo con los proveedores necesarios para prestar el servicio: Meta (WhatsApp, Instagram y Messenger), Shopify, operadores logísticos y transportadoras, pasarelas y entidades de pago, proveedores de inteligencia artificial y de infraestructura. Cada uno trata los datos según sus propias políticas.</p>

        <h2>5. Integración con Meta</h2>
        <p>La plataforma usa las API oficiales de Meta. Los mensajes se procesan para ser mostrados y respondidos dentro de {SITE.brand} y no se usan para fines distintos a los autorizados por el usuario y por las políticas de Meta.</p>

        <h2>6. Seguridad y conservación</h2>
        <p>La información de cada empresa está aislada, el acceso se controla por roles y se realizan copias de seguridad diarias. Conservamos los datos mientras la cuenta esté activa o mientras sea necesario para cumplir obligaciones legales.</p>

        <h2>7. Tus derechos</h2>
        <p>Puedes conocer, actualizar, rectificar y solicitar la eliminación de tus datos, y revocar la autorización, como se explica en nuestra <a href="/tratamiento-datos">Política de Tratamiento de Datos Personales</a>. Para eliminar datos, sigue las instrucciones de <a href="/eliminacion-datos">Eliminación de datos</a>.</p>

        <h2>8. Cookies</h2>
        <p>Consulta nuestra <a href="/cookies">Política de Cookies</a>.</p>
      </>
    ),
  },

  'tratamiento-datos': {
    title: 'Política de Tratamiento de Datos Personales',
    body: () => (
      <>
        <p>Esta política se expide en cumplimiento de la Ley 1581 de 2012, el Decreto 1377 de 2013 (compilado en el Decreto 1074 de 2015) y demás normas colombianas sobre protección de datos personales (Habeas Data).</p>

        <h2>1. Responsable</h2>
        <p><OWNER />. Correo: <EMAIL />.</p>

        <h2>2. Roles en el tratamiento</h2>
        <p>Frente a los datos de los usuarios de la plataforma, {SITE.brand} actúa como <b>Responsable</b>. Frente a los datos de los clientes finales que cada empresa gestiona en la plataforma, la empresa usuaria es la Responsable y {SITE.brand} actúa como <b>Encargado</b>, tratando esos datos únicamente por cuenta y según las instrucciones de la empresa usuaria.</p>

        <h2>3. Finalidades</h2>
        <ul>
          <li>Prestar, mantener y mejorar el servicio de la plataforma.</li>
          <li>Gestionar conversaciones, pedidos, pagos, envíos y notificaciones.</li>
          <li>Brindar soporte y atender solicitudes.</li>
          <li>Enviar información sobre el servicio y, con autorización, comunicaciones comerciales.</li>
          <li>Cumplir obligaciones legales y contractuales.</li>
        </ul>

        <h2>4. Derechos de los titulares</h2>
        <ul>
          <li>Conocer, actualizar y rectificar sus datos.</li>
          <li>Solicitar prueba de la autorización otorgada.</li>
          <li>Ser informado sobre el uso que se ha dado a sus datos.</li>
          <li>Presentar quejas ante la Superintendencia de Industria y Comercio.</li>
          <li>Revocar la autorización y/o solicitar la supresión de sus datos cuando no exista un deber legal o contractual de conservarlos.</li>
          <li>Acceder gratuitamente a sus datos.</li>
        </ul>

        <h2>5. Consultas y reclamos</h2>
        <p>Las solicitudes pueden enviarse a <EMAIL />, indicando nombre, identificación, datos de contacto y la descripción de la solicitud. Las consultas se atienden en un plazo máximo de diez (10) días hábiles y los reclamos en un plazo máximo de quince (15) días hábiles, prorrogables en los términos de la ley.</p>
        <p>Si eres cliente de una empresa que usa {SITE.brand}, puedes dirigir tu solicitud directamente a esa empresa, o escribirnos y la trasladaremos a ella.</p>

        <h2>6. Seguridad</h2>
        <p>Aplicamos medidas técnicas y administrativas razonables para proteger los datos contra acceso no autorizado, pérdida o alteración.</p>

        <h2>7. Vigencia</h2>
        <p>Esta política rige desde su publicación. Los datos se conservarán mientras sean necesarios para las finalidades descritas.</p>
      </>
    ),
  },

  cookies: {
    title: 'Política de Cookies',
    body: () => (
      <>
        <h2>1. Qué usamos</h2>
        <p>{SITE.brand} utiliza almacenamiento local del navegador y tecnologías similares a las cookies para mantener tu sesión iniciada y recordar tus preferencias dentro de la plataforma. Son necesarias para que el servicio funcione.</p>

        <h2>2. Terceros</h2>
        <p>Algunos recursos, como tipografías o contenido multimedia, pueden cargarse desde servidores de terceros, que pueden registrar información técnica de la conexión. Actualmente no usamos cookies publicitarias.</p>

        <h2>3. Cómo controlarlas</h2>
        <p>Puedes borrar o bloquear el almacenamiento del sitio desde la configuración de tu navegador. Si lo haces, tendrás que iniciar sesión de nuevo y algunas funciones pueden no estar disponibles.</p>

        <h2>4. Contacto</h2>
        <p>Si tienes preguntas, escríbenos a <EMAIL />.</p>
      </>
    ),
  },

  'eliminacion-datos': {
    title: 'Eliminación de datos',
    body: () => (
      <>
        <p>Puedes solicitar en cualquier momento la eliminación de tus datos personales tratados por {SITE.brand}, incluidos los obtenidos a través de WhatsApp, Instagram, Messenger u otros servicios de Meta.</p>

        <h2>Cómo solicitarla</h2>
        <ol>
          <li>Envía un correo a <EMAIL /> con el asunto <b>"Eliminación de datos"</b>.</li>
          <li>Incluye tu nombre y el número de teléfono o correo asociado a tus datos.</li>
          <li>Si eres usuario de la plataforma, indica también la empresa o cuenta.</li>
        </ol>

        <h2>Qué pasa después</h2>
        <p>Confirmaremos la recepción de tu solicitud y eliminaremos tus datos en un plazo máximo de quince (15) días hábiles, salvo la información que debamos conservar por obligación legal o contractual, de lo cual te informaremos.</p>
        <p>Si eres cliente de una empresa que usa {SITE.brand}, también puedes pedir la eliminación directamente a esa empresa.</p>
      </>
    ),
  },
};

const CSS = `
.lg-root{font-family:'SF Pro Display','SF Pro Text',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;color:#0a0a0a;background:#fff;min-height:100vh;-webkit-font-smoothing:antialiased}
.lg-root *{box-sizing:border-box}
.lg-bar{border-bottom:1px solid #e8e8e6}
.lg-bar-in{max-width:820px;margin:0 auto;padding:0 24px;height:64px;display:flex;align-items:center;justify-content:space-between}
.lg-bar img{height:28px;display:block}
.lg-bar a.lg-back{font-size:15px;color:#6b7280;text-decoration:none}
.lg-bar a.lg-back:hover{color:#0a0a0a}
.lg-main{max-width:820px;margin:0 auto;padding:56px 24px 80px}
.lg-main h1{font-size:clamp(30px,5vw,42px);letter-spacing:-.03em;line-height:1.1;margin:0 0 8px}
.lg-date{color:#9ca3af;font-size:14px;margin:0 0 40px}
.lg-main h2{font-size:20px;letter-spacing:-.01em;margin:36px 0 10px}
.lg-main p,.lg-main li{font-size:16px;line-height:1.7;color:#374151}
.lg-main ul,.lg-main ol{padding-left:22px}
.lg-main a{color:#0a0a0a}
.lg-missing{background:#fef3c7;color:#92400e;padding:0 4px;border-radius:4px}
.lg-foot{border-top:1px solid #e8e8e6;padding:28px 24px;text-align:center;font-size:14px;color:#6b7280}
.lg-foot a{color:#6b7280;margin:0 10px;text-decoration:none;display:inline-block;padding:4px 0}
.lg-foot a:hover{color:#0a0a0a}
@media (max-width:640px){.lg-bar-in,.lg-main{padding-left:16px;padding-right:16px}.lg-main{padding-top:40px}}
`;

export const LEGAL_PATHS = Object.keys(PAGES).map(k => '/' + k);

export default function Legal({ page }) {
  const p = PAGES[page];
  if (!p) return null;
  const Body = p.body;
  return (
    <div className="lg-root">
      <style>{CSS}</style>
      <header className="lg-bar">
        <div className="lg-bar-in">
          <a href="/" aria-label={SITE.brand}><img src="/logo-talku.png" alt={SITE.brand} /></a>
          <a href="/" className="lg-back">← Volver al inicio</a>
        </div>
      </header>
      <main className="lg-main">
        <h1>{p.title}</h1>
        <p className="lg-date">Última actualización: {SITE.legalUpdated}</p>
        <Body />
      </main>
      <footer className="lg-foot">
        <a href="/terminos">Términos</a>
        <a href="/privacidad">Privacidad</a>
        <a href="/tratamiento-datos">Tratamiento de datos</a>
        <a href="/cookies">Cookies</a>
        <a href="/eliminacion-datos">Eliminación de datos</a>
      </footer>
    </div>
  );
}
